import type { ReactNode } from 'react';
import './AppLayout.css';

/**
 * W02 — compound layout: AppLayout.Root / TopBar / Sidebar / BottomNav / DelinquencyBanner / Content.
 * Mobile-first (< 768px bottom nav); desktop gets a sidebar fallback.
 */
export function AppLayoutRoot({ children }: { children: ReactNode }) {
  return <div className="app-shell">{children}</div>;
}

export function AppLayoutContent({ children }: { children: ReactNode }) {
  return (
    <main className="app-content" id="main-content">
      {children}
    </main>
  );
}

export const AppLayout = {
  Root: AppLayoutRoot,
  Content: AppLayoutContent,
};
